import React from 'react';
import EmailForm from './EmailForm';
import './LandingPage.css';
import HowItWorks from './HowItWorks';
import ui1 from './ui3.png';

// header section
const Header = () => {
    return (
        <header className="header">
            <a className='homelink' href='/'>
                <div className="logo-container">
                    <div className='logo'></div>
                    <div className="logo-placeholder"> <h3>Warm Domains</h3></div>
                </div>
            </a>
            <nav className="nav-links">
                <a href="#home" className="nav-link">Home</a>
                <a href="#features" className="nav-link">Features</a>
                <a href="#pricing" className="nav-link">Pricing</a>
                <a href="#contact" className="nav-link">Contact</a>
            </nav>
        </header>
    );
};

// hero section
const Title = () => {
    return (
        <section className="hero-section">
            <div className="hero-content">
                <h1 className="hero-headline">
                    Send Cold Emails Like You Own The Web
                </h1>
                <p className="hero-body">
                    Domains warmed up for at least 6 months, ready for max volume sending and 100% delivery rates.
                </p>
                <EmailForm />
                <div className="product-image-section">
                    <img
                        src={ui1}
                        alt="Product UI Preview"
                        className="product-image"
                    />
                </div>
            </div>
        </section>
    );
};

// features section
const Features = () => {
    return (
        <section className="features-section" id="features">
            <div className="features-content">
                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon">🚀</div>
                        <h3 className="feature-title">Instant Authority</h3>
                        <p className="feature-description">
                            Skip the 6-month warmup phase. Our domains come with established history and trust scores.
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">🛡️</div>
                        <h3 className="feature-title">Spam-Proof Assurance</h3>
                        <p className="feature-description">
                            Pre-validated against major blacklists. We ensure 100% healthy reputation before handoff.
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon">⚡</div>
                        <h3 className="feature-title">Max Volume Ready</h3>
                        <p className="feature-description">
                            Start sending thousands of emails on Day 1 without triggering spam filters or ISP blocks.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

// benefits section
const Benefits = () => {
    return (
        <section className="benefits-section">
            <div className="benefits-content">
                <h2 className="benefits-headline">Why Choose Us?</h2>
                <div className="benefits-grid">
                    <div className="benefit-card">
                        <h3 className="benefit-title">The "Seasoned Agent" Effect</h3>
                        <p className="benefit-text">
                            Each domain is equivalent to hiring a marketing agent with 6+ months of high-quality sending history.
                            ISP algorithms treat our domains as established entities, not new risks.
                        </p>
                    </div>
                    <div className="benefit-card">
                        <h3 className="benefit-title">100% Hit Rate Guarantee</h3>
                        <p className="benefit-text">
                            Your campaign is guaranteed to have optimal deliverability.
                            We've done the heavy lifting of warming up so you can focus on closing deals, not technical configuration.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

// pricing section
const Pricing = () => {
    const [selectedPlan, setSelectedPlan] = React.useState('');

    return (
        <section className="pricing-section" id="pricing">
            <div className="pricing-content">
                <h2 className="pricing-headline">Simple, Transparent Pricing</h2>
                <p className="pricing-subheading">
                    Stop burning through domains. Invest in assets that land in the inbox.
                </p>

                <div className="pricing-grid">
                    {/* Starter Plan */}
                    <div
                        className={`pricing-card ${selectedPlan === 'Starter' ? 'selected' : ''}`}
                        onClick={() => setSelectedPlan('Starter')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="pricing-header">
                            <h3 className="plan-name">Starter</h3>
                            <div className="price">
                                <span className="currency">$</span>
                                <span className="amount">95</span>
                                <span className="period">/domain</span>
                            </div>
                            <p className="plan-description">Perfect for validating a new offer or small campaigns.</p>
                        </div>
                        <ul className="feature-list">
                            <li><span className="check">✓</span> 1 Premium Warmed Domain</li>
                            <li><span className="check">✓</span> 30-Day Replacement Guarantee</li>
                            <li><span className="check">✓</span> SPF, DKIM, DMARC Setup</li>
                            <li><span className="check">✓</span> Ready to send 500+ daily</li>
                        </ul>
                        <a href="#" className="pricing-button" onClick={(e) => e.stopPropagation()}>Get Started</a>
                    </div>

                    {/* Growth Plan - Highlighted */}
                    <div
                        className={`pricing-card  ${selectedPlan === 'Growth' ? 'selected' : ''}`}
                        onClick={() => setSelectedPlan('Growth')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="popular-badge">Most Popular</div>
                        <div className="pricing-header">
                            <h3 className="plan-name">Growth</h3>
                            <div className="price">
                                <span className="currency">$</span>
                                <span className="amount">250</span>
                                <span className="period">/3 domains</span>
                            </div>
                            <p className="plan-description">Scale your outreach volume without the headache.</p>
                        </div>
                        <ul className="feature-list">
                            <li><span className="check">✓</span> 3 Premium Warmed Domains</li>
                            <li><span className="check">✓</span> Priority Support</li>
                            <li><span className="check">✓</span> Dedicated IP Option</li>
                            <li><span className="check">✓</span> Ready to send 2000+ daily</li>
                        </ul>
                        <a href="#" className="pricing-button primary" onClick={(e) => e.stopPropagation()}>Get Growth Pack</a>
                    </div>

                    {/* Agency Plan */}
                    <div
                        className={`pricing-card ${selectedPlan === 'Agency' ? 'selected' : ''}`}
                        onClick={() => setSelectedPlan('Agency')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="pricing-header">
                            <h3 className="plan-name">Agency</h3>
                            <div className="price">
                                <span className="amount">Custom</span>
                            </div>
                            <p className="plan-description">High volume infrastructure for lead gen agencies.</p>
                        </div>
                        <ul className="feature-list">
                            <li><span className="check">✓</span> Bulk Domain Discounts</li>
                            <li><span className="check">✓</span> API Access</li>
                            <li><span className="check">✓</span> White-label Reports</li>
                            <li><span className="check">✓</span> Dedicated Account Manager</li>
                        </ul>
                        <a href="#" className="pricing-button" onClick={(e) => e.stopPropagation()}>Contact Sales</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

const FAQ = () => {
    const [activeIndex, setActiveIndex] = React.useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "Do I get full access to the domain DNS?",
            answer: "Yes. You receive full ownership and DNS control. We transfer the domain to your registrar account or provide you with the login credentials, ensuring you have 100% control over your infrastructure."
        },
        {
            question: "How long have these domains been warming up?",
            answer: "Every domain in our inventory has been warmed up for a minimum of 6 months using human-like interaction patterns. They are ready for high-volume sending immediately upon purchase."
        },
        {
            question: "What TLDs (Top Level Domains) do you offer?",
            answer: "We primarily stock .com, .net, and .io domains as they carry the highest trust scores with ISPs. We avoid cheap TLDs (like .xyz or .info) that are often flagged as spam."
        },
        {
            question: "What happens if a domain gets blacklisted?",
            answer: "Our 'Growth' and 'Agency' plans come with a 30-day replacement guarantee. If a domain hits a blacklist despite following our best practices, we will replace it for free, no questions asked."
        }
    ];

    return (
        <section className="faq-section">
            <div className="faq-content">
                <h2 className="faq-headline">Frequently Asked Questions</h2>
                <div className="faq-list">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="faq-question">
                                {faq.question}
                                <span className="faq-icon">+</span>
                            </div>
                            <div className="faq-answer">
                                {faq.answer}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

// footer section
const Footer = () => {
    return (
        <footer className="footer">
            <p>
                © 2025 Warm Domains • <a href="mailto:hello@warmdomains.com" className="footer-link">hello@warmdomains.com</a> •
                <a href="/terms" className="footer-link">Terms</a> •
                <a href="/privacy" className="footer-link">Privacy</a>
            </p>
        </footer>
    );
};

const LandingPage = () => {
    return (
        <div className="landing-page-container" id='home'>
            <Header />
            <Title />
            <Features />
            <Benefits />
            <HowItWorks />
            <Pricing />
            <FAQ />
            <Footer />
        </div>
    );
};


export default LandingPage;